module.exports = Object.is || function is(x, y){
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/$.same.js
 ** module id = 104
 ** module chunks = 0
 **/